module.exports = __webpack_public_path__ + "assets/img/close.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/close.png
// module id = 1936
// module chunks = 0